export default __webpack_public_path__ + "static/media/ic-card.fde16f93.svg";